
export default {

    /*
    - live URL
    - endpoint submit4
    */
    baseEndPoint: 'https://einfach-alles-erklären.at',  // live endpoint
    //baseEndPoint: 'http://localhost:7001',   // local server development
};